import React from 'react';
import Card from '../../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const MarketShareTrendChart: React.FC = () => {
  const data = [{
    quarter: 'Q1 FY23',
    twoWheeler: 14.2,
    threeWheeler: 8.5,
    fourWheeler: 11.8,
    overall: 11.5
  }, {
    quarter: 'Q2 FY23',
    twoWheeler: 14.5,
    threeWheeler: 8.8,
    fourWheeler: 12.1,
    overall: 11.8
  }, {
    quarter: 'Q3 FY23',
    twoWheeler: 14.8,
    threeWheeler: 9.2,
    fourWheeler: 12.3,
    overall: 12.1
  }, {
    quarter: 'Q4 FY23',
    twoWheeler: 15.0,
    threeWheeler: 9.5,
    fourWheeler: 12.5,
    overall: 12.3
  }, {
    quarter: 'Q1 FY24',
    twoWheeler: 15.2,
    threeWheeler: 9.8,
    fourWheeler: 12.7,
    overall: 12.6
  }, {
    quarter: 'Q2 FY24',
    twoWheeler: 15.4,
    threeWheeler: 10.1,
    fourWheeler: 12.9,
    overall: 12.8
  }];
  const segmentSummary = [{
    segment: '2-Wheeler',
    current: 15.4,
    change: '+1.2%',
    rank: '#2',
    color: 'text-blue-600'
  }, {
    segment: '3-Wheeler',
    current: 10.1,
    change: '+1.6%',
    rank: '#3',
    color: 'text-green-600'
  }, {
    segment: '4-Wheeler',
    current: 12.9,
    change: '+1.1%',
    rank: '#4',
    color: 'text-purple-600'
  }, {
    segment: 'Overall',
    current: 12.8,
    change: '+1.3%',
    rank: '#3',
    color: 'text-orange-600'
  }];
  return <Card className="p-6 mb-8" data-id="element-7812">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7813">
        Market Share Trend by Segment
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7814">
        India automotive market share evolution (%)
      </p>
      <ResponsiveContainer width="100%" height={350} data-id="element-7815">
        <LineChart data={data} data-id="element-7816">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7817" />
          <XAxis dataKey="quarter" tick={{
          fontSize: 12
        }} data-id="element-7818" />
          <YAxis tick={{
          fontSize: 12
        }} domain={[7, 16]} data-id="element-7819" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `${value}%`} data-id="element-7820" />
          <Legend data-id="element-7821" />
          <Line type="monotone" dataKey="twoWheeler" stroke="#3b82f6" strokeWidth={3} name="2-Wheeler" dot={{
          r: 5,
          strokeWidth: 2
        }} data-id="element-7822" />
          <Line type="monotone" dataKey="threeWheeler" stroke="#10b981" strokeWidth={3} name="3-Wheeler" dot={{
          r: 5,
          strokeWidth: 2
        }} data-id="element-7823" />
          <Line type="monotone" dataKey="fourWheeler" stroke="#8b5cf6" strokeWidth={3} name="4-Wheeler" dot={{
          r: 5,
          strokeWidth: 2
        }} data-id="element-7824" />
          <Line type="monotone" dataKey="overall" stroke="#f59e0b" strokeWidth={4} strokeDasharray="5 5" name="Overall Market" dot={{
          r: 6,
          strokeWidth: 2
        }} data-id="element-7825" />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-7826">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-7827">
          {segmentSummary.map((item, index) => <div key={index} className="text-center" data-id="element-7828">
              <div className="text-xs text-gray-600 mb-1" data-id="element-7829">{item.segment}</div>
              <div className={`text-2xl font-bold ${item.color}`} data-id="element-7830">
                {item.current}%
              </div>
              <div className="text-xs text-green-600 font-semibold mt-1" data-id="element-7831">
                {item.change} YoY
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-7832">
                Market Rank: {item.rank}
              </div>
            </div>)}
        </div>
      </div>
      <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-7833">
        <div className="flex items-start" data-id="element-7834">
          <div className="flex-shrink-0 w-2 h-2 rounded-full bg-blue-600 mt-1.5 mr-2" data-id="element-7835" />
          <div className="text-sm text-blue-800" data-id="element-7836">
            <span className="font-semibold" data-id="element-7837">Key Insight:</span> 2-Wheeler
            segment showing strongest market position at 15.4% share, driven by
            LED headlamp adoption and cost-competitive polymer parts. 3-Wheeler
            segment fastest growing with 1.6% YoY gain.
          </div>
        </div>
      </div>
    </Card>;
};
export default MarketShareTrendChart;